import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Route from '@mui/icons-material/Route';
import Schema from '@mui/icons-material/Schema';
import Summarize from '@mui/icons-material/Summarize';
import TableView from '@mui/icons-material/TableView';
import { sectionLabelSx } from '../dashboard/styles';

const INCLUDES = [
  { Icon: Summarize, label: 'API overview', desc: 'Every operation and schema at a glance' },
  { Icon: Route, label: 'Operation details', desc: 'Methods, paths, summaries and descriptions' },
  { Icon: Schema, label: 'Data schemas', desc: 'Request and response fields, types and required flags' },
  { Icon: TableView, label: 'Excel format', desc: 'One tab per section, ready to share with customers' },
];

/** Static explainer; renders once. */
const WorkbookIncludes: React.FC = () => (
  <Box component="section" aria-labelledby="workbook-includes" sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, px: 0.5, pt: 0.5 }}>
    <Typography id="workbook-includes" component="h2" sx={sectionLabelSx}>
      The workbook includes
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 1fr))', gap: 1.5 }}>
      {INCLUDES.map(({ Icon, label, desc }) => (
        <Box key={label} sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}>
          <Icon sx={{ fontSize: 20, color: 'primary.dark' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{label}</Typography>
            <Typography sx={{ fontSize: 12, lineHeight: 1.4, color: 'text.secondary' }}>{desc}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

export default React.memo(WorkbookIncludes);
